export const GET_FORECAST = 'getForecast'
export const GET_FORECAST_DATA = 'getForecastData'
export const GET_FORECAST_LINE_GRAPH_DATA = 'getForecastLineGraphData'

export const TAG_FORECAST = 'FORECAST'
export const TAG_FORECAST_GRAPH_DATA = 'FORECAST_GRAPH_DATA'

export default [TAG_FORECAST, TAG_FORECAST_GRAPH_DATA]
